var yt = Object.defineProperty, Mt = Object.defineProperties;
var Lt = Object.getOwnPropertyDescriptors;
var ge = Object.getOwnPropertySymbols;
var Re = Object.prototype.hasOwnProperty, Pe = Object.prototype.propertyIsEnumerable;
var Ee = Math.pow, Be = (n, r, c) => r in n ? yt(n, r, { enumerable: !0, configurable: !0, writable: !0, value: c }) : n[r] = c, l = (n, r) => {
  for (var c in r || (r = {}))
    Re.call(r, c) && Be(n, c, r[c]);
  if (ge)
    for (var c of ge(r))
      Pe.call(r, c) && Be(n, c, r[c]);
  return n;
}, s = (n, r) => Mt(n, Lt(r));
var P = (n, r) => {
  var c = {};
  for (var p in n)
    Re.call(n, p) && r.indexOf(p) < 0 && (c[p] = n[p]);
  if (n != null && ge)
    for (var p of ge(n))
      r.indexOf(p) < 0 && Pe.call(n, p) && (c[p] = n[p]);
  return c;
};
import { jsx as e, jsxs as a, Fragment as _ } from "react/jsx-runtime";
import { useState as D, forwardRef as ue, useMemo as At, useCallback as Ne, useEffect as De } from "react";
import { EditorContent as Ue, useEditor as xt } from "@tiptap/react";
import St from "@tiptap/starter-kit";
import It from "@tiptap/extension-text-align";
import Tt from "@tiptap/extension-link";
import Ft from "@tiptap/extension-font-family";
import Ht from "@tiptap/extension-text-style";
import { Color as wt } from "@tiptap/extension-color";
import { FontSize as zt } from "./extensions/font-size.js";
import { Label as Bt } from "../Label/index.js";
import { ErrorMessage as Rt } from "../../molecules/ErrorMessage/index.js";
import { c as d } from "../../RichText.module-C24pyxEt.js";
import { Button as I } from "../Button/index.js";
import { a as it, T } from "../../index-DQlXZnz5.js";
import { BoldFasFAIcon as $e, ItalicFasFAIcon as _e, UnderlineFasFAIcon as Ge, StrikeThroughFasFAIcon as je, FontFasFAIcon as Pt, TextSlashFasFAIcon as ye, ArrowRotateLeftFAIcon as Et, ArrowRotateRightFAIcon as Nt, CaretDownFasFAIcon as ne, TextSizeFasFAIcon as Dt, AlignLeftFAIcon as Me, AlignCenterFAIcon as Oe, AlignRightFAIcon as qe, AlignJustifyFAIcon as Je, LineHeightFasFAIcon as Ut, ListUlFAIcon as $t, ListOlFAIcon as _t, LinkSlashFarFAIcon as Gt, LinkFarFAIcon as jt, ImageFasFAIcon as Ot, PlusFarFAIcon as We, TableListFasFAIcon as Ke, ArrowLeftToLineFAIcon as Xe, ArrowRightToLineFAIcon as Ve, XMarkFarFAIcon as Ce, ArrowUpToLineFAIcon as Qe, ArrowToBottomFarFAIcon as Ye, MergeFAIcon as Ze, SplitFAIcon as et, TableFarFAIcon as tt, TrashFarFAIcon as nt, MinusSolidFAIcon as qt, LayerGroupFarFAIcon as Jt, CodeFasFAIcon as Wt } from "../Icons/index.js";
import { Menu as o } from "../Menu/index.js";
import Kt from "@tiptap/extension-highlight";
import { TextField as be } from "../TextField/index.js";
import { FileDropzone as Xt } from "../FileDropzone/index.js";
import Vt from "@tiptap/extension-image";
import { FloatingImageToolbar as Qt } from "./FloatingImageToolbar.js";
import Yt from "@tiptap/extension-underline";
import { LineHeight as Zt } from "./extensions/line-height.js";
import en from "@tiptap/extension-table";
import tn from "@tiptap/extension-table-row";
import nn from "@tiptap/extension-table-header";
import ln from "@tiptap/extension-table-cell";
import an from "@tiptap/extension-code-block";
import { c as on } from "../../create-safe-context-DqDyoPVE.js";
import { n as rt, I as ct, b as rn, o as ve, f as q, u as U, l as cn, B as X } from "../../factory-ueRxoNOV.js";
import { u as Ae } from "../../use-styles-DToiHEa6.js";
import { U as st } from "../../UnstyledButton-D9OCzDhz.js";
import { u as ht } from "../../use-disclosure-Do3DbqlJ.js";
import { u as sn } from "../../use-window-event-XS3iBc75.js";
import { u as hn } from "../../use-resolved-styles-api-D-aL_8KF.js";
import { P as le } from "../../Popover-COBqkLTt.js";
import { I as dt } from "../../InputBase-Cabx1d9o.js";
import { r as E } from "../../rem-CMQJ_ZTp.js";
import { B as dn } from "../../Button-D50dlMrD.js";
import { C as pe, a as pn, A as se } from "../../ColorPicker-BjXFwAa-.js";
import { g as ae, a as un, p as lt } from "../../get-base-value-DBR0fUhH.js";
import { b as K } from "../../get-size-Bc1Pz5yf.js";
import { G as mn } from "../../Group-CbE78j-X.js";
import { F as w } from "../../Flex-BcSdq2bJ.js";
import { D as Z } from "../../Divider-CB6EOLnF.js";
import { S as he } from "../../Stack-CTaaXTID.js";
import { T as de } from "../../Text-B7Ta53Id.js";
function fn(n) {
  return (r) => {
    if (!r)
      n(r);
    else if (typeof r == "function")
      n(r);
    else if (typeof r == "object" && "nativeEvent" in r) {
      const { currentTarget: c } = r;
      c.type === "checkbox" ? n(c.checked) : n(c.value);
    } else
      n(r);
  };
}
function gn(n) {
  const [r, c] = D(n);
  return [r, fn(c)];
}
function Cn({
  spacing: n,
  verticalSpacing: r,
  cols: c,
  selector: p
}) {
  var b;
  const g = rn(), C = r === void 0 ? n : r, f = rt({
    "--sg-spacing-x": K(ae(n)),
    "--sg-spacing-y": K(ae(C)),
    "--sg-cols": (b = ae(c)) == null ? void 0 : b.toString()
  }), u = ve(g.breakpoints).reduce(
    (m, L) => (m[L] || (m[L] = {}), typeof n == "object" && n[L] !== void 0 && (m[L]["--sg-spacing-x"] = K(n[L])), typeof C == "object" && C[L] !== void 0 && (m[L]["--sg-spacing-y"] = K(C[L])), typeof c == "object" && c[L] !== void 0 && (m[L]["--sg-cols"] = c[L]), m),
    {}
  ), M = un(ve(u), g.breakpoints).filter(
    (m) => ve(u[m.value]).length > 0
  ).map((m) => ({
    query: `(min-width: ${g.breakpoints[m.value]})`,
    styles: u[m.value]
  }));
  return /* @__PURE__ */ e(ct, { styles: f, media: M, selector: p });
}
function Le(n) {
  return typeof n == "object" && n !== null ? ve(n) : [];
}
function bn(n) {
  return n.sort((r, c) => lt(r) - lt(c));
}
function vn({
  spacing: n,
  verticalSpacing: r,
  cols: c
}) {
  const p = Array.from(
    /* @__PURE__ */ new Set([
      ...Le(n),
      ...Le(r),
      ...Le(c)
    ])
  );
  return bn(p);
}
function kn({
  spacing: n,
  verticalSpacing: r,
  cols: c,
  selector: p
}) {
  var M;
  const g = r === void 0 ? n : r, C = rt({
    "--sg-spacing-x": K(ae(n)),
    "--sg-spacing-y": K(ae(g)),
    "--sg-cols": (M = ae(c)) == null ? void 0 : M.toString()
  }), f = vn({ spacing: n, verticalSpacing: r, cols: c }), u = f.reduce(
    (b, m) => (b[m] || (b[m] = {}), typeof n == "object" && n[m] !== void 0 && (b[m]["--sg-spacing-x"] = K(n[m])), typeof g == "object" && g[m] !== void 0 && (b[m]["--sg-spacing-y"] = K(g[m])), typeof c == "object" && c[m] !== void 0 && (b[m]["--sg-cols"] = c[m]), b),
    {}
  ), v = f.map((b) => ({
    query: `simple-grid (min-width: ${b})`,
    styles: u[b]
  }));
  return /* @__PURE__ */ e(ct, { styles: C, container: v, selector: p });
}
var pt = { container: "m_925c2d2c", root: "m_2415a157" };
const yn = {
  cols: 1,
  spacing: "md",
  type: "media"
}, xe = q((n, r) => {
  const c = U("SimpleGrid", yn, n), z = c, {
    classNames: p,
    className: g,
    style: C,
    styles: f,
    unstyled: u,
    vars: v,
    cols: M,
    verticalSpacing: b,
    spacing: m,
    type: L
  } = z, k = P(z, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "cols",
    "verticalSpacing",
    "spacing",
    "type"
  ]), F = Ae({
    name: "SimpleGrid",
    classes: pt,
    props: c,
    className: g,
    style: C,
    classNames: p,
    styles: f,
    unstyled: u,
    vars: v
  }), H = cn();
  return L === "container" ? /* @__PURE__ */ a(_, { children: [
    /* @__PURE__ */ e(kn, s(l({}, c), { selector: `.${H}` })),
    /* @__PURE__ */ e("div", s(l({}, F("container")), { children: /* @__PURE__ */ e(X, l(l({ ref: r }, F("root", { className: H })), k)) }))
  ] }) : /* @__PURE__ */ a(_, { children: [
    /* @__PURE__ */ e(Cn, s(l({}, c), { selector: `.${H}` })),
    /* @__PURE__ */ e(X, l(l({ ref: r }, F("root", { className: H })), k))
  ] });
});
xe.classes = pt;
xe.displayName = "@mantine/core/SimpleGrid";
const Mn = {}, Se = q((n, r) => {
  const c = U("TextInput", Mn, n);
  return /* @__PURE__ */ e(dt, s(l({ component: "input", ref: r }, c), { __staticSelector: "TextInput" }));
});
Se.classes = dt.classes;
Se.displayName = "@mantine/core/TextInput";
var ut = { root: "m_d6493fad" };
const Ln = {}, Ie = q((n, r) => {
  const c = U("TypographyStylesProvider", Ln, n), b = c, { classNames: p, className: g, style: C, styles: f, unstyled: u } = b, v = P(b, ["classNames", "className", "style", "styles", "unstyled"]), M = Ae({
    name: "TypographyStylesProvider",
    classes: ut,
    props: c,
    className: g,
    style: C,
    classNames: p,
    styles: f,
    unstyled: u
  });
  return /* @__PURE__ */ e(X, l(l({ ref: r }, M("root")), v));
});
Ie.classes = ut;
Ie.displayName = "@mantine/core/TypographyStylesProvider";
var ee = { root: "m_dd3f7539", typographyStylesProvider: "m_d37966d9", content: "m_c2204cc2", linkEditorDropdown: "m_8a991b4f", control: "m_c2207da6", controlIcon: "m_9cdfeb3f", controlsGroup: "m_2ab47ef2", linkEditor: "m_b67b711e", linkEditorInput: "m_296cf94c", linkEditorExternalControl: "m_cfef614", linkEditorSave: "m_3b28e7bb", toolbar: "m_4574a3c4", taskList: "m_8b44009a" };
const An = {
  // Controls labels
  linkControlLabel: "Link",
  colorPickerControlLabel: "Text color",
  highlightControlLabel: "Highlight text",
  colorControlLabel: (n) => `Set text color ${n}`,
  boldControlLabel: "Bold",
  italicControlLabel: "Italic",
  underlineControlLabel: "Underline",
  strikeControlLabel: "Strikethrough",
  clearFormattingControlLabel: "Clear formatting",
  unlinkControlLabel: "Remove link",
  bulletListControlLabel: "Bullet list",
  orderedListControlLabel: "Ordered list",
  h1ControlLabel: "Heading 1",
  h2ControlLabel: "Heading 2",
  h3ControlLabel: "Heading 3",
  h4ControlLabel: "Heading 4",
  h5ControlLabel: "Heading 5",
  h6ControlLabel: "Heading 6",
  blockquoteControlLabel: "Blockquote",
  alignLeftControlLabel: "Align text: left",
  alignCenterControlLabel: "Align text: center",
  alignRightControlLabel: "Align text: right",
  alignJustifyControlLabel: "Align text: justify",
  codeControlLabel: "Code",
  codeBlockControlLabel: "Code block",
  subscriptControlLabel: "Subscript",
  superscriptControlLabel: "Superscript",
  unsetColorControlLabel: "Unset color",
  hrControlLabel: "Horizontal line",
  undoControlLabel: "Undo",
  redoControlLabel: "Redo",
  // Task list
  tasksControlLabel: "Task list",
  tasksSinkLabel: "Decrease task level",
  tasksLiftLabel: "Increase task level",
  // Link editor
  linkEditorInputLabel: "Enter URL",
  linkEditorInputPlaceholder: "https://example.com/",
  linkEditorExternalLink: "Open link in a new tab",
  linkEditorInternalLink: "Open link in the same tab",
  linkEditorSave: "Save",
  // Color picker control
  colorPickerCancel: "Cancel",
  colorPickerClear: "Clear color",
  colorPickerColorPicker: "Color picker",
  colorPickerPalette: "Color palette",
  colorPickerSave: "Save",
  colorPickerColorLabel: (n) => `Set text color ${n}`
}, [xn, J] = on("RichTextEditor component was not found in tree"), Sn = {}, Te = q((n, r) => {
  const b = U("RichTextEditorContent", Sn, n), { classNames: p, className: g, style: C, styles: f, vars: u } = b, v = P(b, ["classNames", "className", "style", "styles", "vars"]), M = J();
  return M.withTypographyStyles ? /* @__PURE__ */ e(
    Ie,
    s(l({}, M.getStyles("typographyStylesProvider", { className: g, style: C, styles: f, classNames: p })), {
      unstyled: M.unstyled,
      ref: r,
      children: /* @__PURE__ */ e(
        X,
        l(l({
          component: Ue,
          editor: M.editor
        }, M.getStyles("content", { classNames: p, styles: f })), v)
      )
    })
  ) : /* @__PURE__ */ e(
    X,
    l(l({
      component: Ue,
      editor: M.editor
    }, M.getStyles("content", { classNames: p, styles: f, className: g, style: C })), v)
  );
});
Te.classes = ee;
Te.displayName = "@mantine/tiptap/RichTextEditorContent";
function y(n) {
  return /* @__PURE__ */ e(
    "svg",
    s(l({}, n), {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      strokeWidth: "1.5",
      stroke: "currentColor",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  );
}
function In(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M7 5h6a3.5 3.5 0 0 1 0 7h-6z" }),
    /* @__PURE__ */ e("path", { d: "M13 12h1a3.5 3.5 0 0 1 0 7h-7v-7" })
  ] }));
}
function Tn(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M11 5l6 0" }),
    /* @__PURE__ */ e("path", { d: "M7 19l6 0" }),
    /* @__PURE__ */ e("path", { d: "M14 5l-4 14" })
  ] }));
}
function Fn(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M7 5v5a5 5 0 0 0 10 0v-5" }),
    /* @__PURE__ */ e("path", { d: "M5 19h14" })
  ] }));
}
function Hn(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M5 12l14 0" }),
    /* @__PURE__ */ e("path", { d: "M16 6.5a4 2 0 0 0 -4 -1.5h-1a3.5 3.5 0 0 0 0 7h2a3.5 3.5 0 0 1 0 7h-1.5a4 2 0 0 1 -4 -1.5" })
  ] }));
}
function wn(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M17 15l4 4m0 -4l-4 4" }),
    /* @__PURE__ */ e("path", { d: "M7 6v-1h11v1" }),
    /* @__PURE__ */ e("path", { d: "M7 19l4 0" }),
    /* @__PURE__ */ e("path", { d: "M13 5l-4 14" })
  ] }));
}
function zn(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M19 18v-8l-2 2" }),
    /* @__PURE__ */ e("path", { d: "M4 6v12" }),
    /* @__PURE__ */ e("path", { d: "M12 6v12" }),
    /* @__PURE__ */ e("path", { d: "M11 18h2" }),
    /* @__PURE__ */ e("path", { d: "M3 18h2" }),
    /* @__PURE__ */ e("path", { d: "M4 12h8" }),
    /* @__PURE__ */ e("path", { d: "M3 6h2" }),
    /* @__PURE__ */ e("path", { d: "M11 6h2" })
  ] }));
}
function Bn(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M17 12a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0" }),
    /* @__PURE__ */ e("path", { d: "M4 6v12" }),
    /* @__PURE__ */ e("path", { d: "M12 6v12" }),
    /* @__PURE__ */ e("path", { d: "M11 18h2" }),
    /* @__PURE__ */ e("path", { d: "M3 18h2" }),
    /* @__PURE__ */ e("path", { d: "M4 12h8" }),
    /* @__PURE__ */ e("path", { d: "M3 6h2" }),
    /* @__PURE__ */ e("path", { d: "M11 6h2" })
  ] }));
}
function Rn(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M19 14a2 2 0 1 0 -2 -2" }),
    /* @__PURE__ */ e("path", { d: "M17 16a2 2 0 1 0 2 -2" }),
    /* @__PURE__ */ e("path", { d: "M4 6v12" }),
    /* @__PURE__ */ e("path", { d: "M12 6v12" }),
    /* @__PURE__ */ e("path", { d: "M11 18h2" }),
    /* @__PURE__ */ e("path", { d: "M3 18h2" }),
    /* @__PURE__ */ e("path", { d: "M4 12h8" }),
    /* @__PURE__ */ e("path", { d: "M3 6h2" }),
    /* @__PURE__ */ e("path", { d: "M11 6h2" })
  ] }));
}
function Pn(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M20 18v-8l-4 6h5" }),
    /* @__PURE__ */ e("path", { d: "M4 6v12" }),
    /* @__PURE__ */ e("path", { d: "M12 6v12" }),
    /* @__PURE__ */ e("path", { d: "M11 18h2" }),
    /* @__PURE__ */ e("path", { d: "M3 18h2" }),
    /* @__PURE__ */ e("path", { d: "M4 12h8" }),
    /* @__PURE__ */ e("path", { d: "M3 6h2" }),
    /* @__PURE__ */ e("path", { d: "M11 6h2" })
  ] }));
}
function En(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M17 18h2a2 2 0 1 0 0 -4h-2v-4h4" }),
    /* @__PURE__ */ e("path", { d: "M4 6v12" }),
    /* @__PURE__ */ e("path", { d: "M12 6v12" }),
    /* @__PURE__ */ e("path", { d: "M11 18h2" }),
    /* @__PURE__ */ e("path", { d: "M3 18h2" }),
    /* @__PURE__ */ e("path", { d: "M4 12h8" }),
    /* @__PURE__ */ e("path", { d: "M3 6h2" }),
    /* @__PURE__ */ e("path", { d: "M11 6h2" })
  ] }));
}
function Nn(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M19 14a2 2 0 1 0 0 4a2 2 0 0 0 0 -4z" }),
    /* @__PURE__ */ e("path", { d: "M21 12a2 2 0 1 0 -4 0v4" }),
    /* @__PURE__ */ e("path", { d: "M4 6v12" }),
    /* @__PURE__ */ e("path", { d: "M12 6v12" }),
    /* @__PURE__ */ e("path", { d: "M11 18h2" }),
    /* @__PURE__ */ e("path", { d: "M3 18h2" }),
    /* @__PURE__ */ e("path", { d: "M4 12h8" }),
    /* @__PURE__ */ e("path", { d: "M3 6h2" }),
    /* @__PURE__ */ e("path", { d: "M11 6h2" })
  ] }));
}
function Dn(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M9 6l11 0" }),
    /* @__PURE__ */ e("path", { d: "M9 12l11 0" }),
    /* @__PURE__ */ e("path", { d: "M9 18l11 0" }),
    /* @__PURE__ */ e("path", { d: "M5 6l0 .01" }),
    /* @__PURE__ */ e("path", { d: "M5 12l0 .01" }),
    /* @__PURE__ */ e("path", { d: "M5 18l0 .01" })
  ] }));
}
function Un(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M11 6h9" }),
    /* @__PURE__ */ e("path", { d: "M11 12h9" }),
    /* @__PURE__ */ e("path", { d: "M12 18h8" }),
    /* @__PURE__ */ e("path", { d: "M4 16a2 2 0 1 1 4 0c0 .591 -.5 1 -1 1.5l-3 2.5h4" }),
    /* @__PURE__ */ e("path", { d: "M6 10v-6l-2 2" })
  ] }));
}
function $n(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M17 22v-2" }),
    /* @__PURE__ */ e("path", { d: "M9 15l6 -6" }),
    /* @__PURE__ */ e("path", { d: "M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464" }),
    /* @__PURE__ */ e("path", { d: "M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463" }),
    /* @__PURE__ */ e("path", { d: "M20 17h2" }),
    /* @__PURE__ */ e("path", { d: "M2 7h2" }),
    /* @__PURE__ */ e("path", { d: "M7 2v2" })
  ] }));
}
function _n(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M6 15h15" }),
    /* @__PURE__ */ e("path", { d: "M21 19h-15" }),
    /* @__PURE__ */ e("path", { d: "M15 11h6" }),
    /* @__PURE__ */ e("path", { d: "M21 7h-6" }),
    /* @__PURE__ */ e("path", { d: "M9 9h1a1 1 0 1 1 -1 1v-2.5a2 2 0 0 1 2 -2" }),
    /* @__PURE__ */ e("path", { d: "M3 9h1a1 1 0 1 1 -1 1v-2.5a2 2 0 0 1 2 -2" })
  ] }));
}
function Gn(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M4 6l16 0" }),
    /* @__PURE__ */ e("path", { d: "M4 12l10 0" }),
    /* @__PURE__ */ e("path", { d: "M4 18l14 0" })
  ] }));
}
function jn(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M4 6l16 0" }),
    /* @__PURE__ */ e("path", { d: "M10 12l10 0" }),
    /* @__PURE__ */ e("path", { d: "M6 18l14 0" })
  ] }));
}
function On(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M4 6l16 0" }),
    /* @__PURE__ */ e("path", { d: "M8 12l8 0" }),
    /* @__PURE__ */ e("path", { d: "M6 18l12 0" })
  ] }));
}
function qn(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M4 6l16 0" }),
    /* @__PURE__ */ e("path", { d: "M4 12l16 0" }),
    /* @__PURE__ */ e("path", { d: "M4 18l12 0" })
  ] }));
}
function Jn(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M5 7l8 10m-8 0l8 -10" }),
    /* @__PURE__ */ e("path", { d: "M21 20h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2" })
  ] }));
}
function Wn(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M5 7l8 10m-8 0l8 -10" }),
    /* @__PURE__ */ e("path", { d: "M21 11h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2" })
  ] }));
}
function mt(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M7 8l-4 4l4 4" }),
    /* @__PURE__ */ e("path", { d: "M17 8l4 4l-4 4" }),
    /* @__PURE__ */ e("path", { d: "M14 4l-4 16" })
  ] }));
}
function Kn(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M3 19h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" }),
    /* @__PURE__ */ e("path", { d: "M12.5 5.5l4 4" }),
    /* @__PURE__ */ e("path", { d: "M4.5 13.5l4 4" }),
    /* @__PURE__ */ e("path", { d: "M21 15v4h-8l4 -4z" })
  ] }));
}
function Xn(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M5 12h2" }),
    /* @__PURE__ */ e("path", { d: "M17 12h2" }),
    /* @__PURE__ */ e("path", { d: "M11 12h2" })
  ] }));
}
function ft(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73" }),
    /* @__PURE__ */ e("path", { d: "M3 3l18 18" })
  ] }));
}
function Vn(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M11 7l6 6" }),
    /* @__PURE__ */ e("path", { d: "M4 16l11.7 -11.7a1 1 0 0 1 1.4 0l2.6 2.6a1 1 0 0 1 0 1.4l-11.7 11.7h-4v-4z" })
  ] }));
}
function Qn(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M18 6l-12 12" }),
    /* @__PURE__ */ e("path", { d: "M6 6l12 12" })
  ] }));
}
function Yn(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M12 21a9 9 0 0 1 0 -18c4.97 0 9 3.582 9 8c0 1.06 -.474 2.078 -1.318 2.828c-.844 .75 -1.989 1.172 -3.182 1.172h-2.5a2 2 0 0 0 -1 3.75a1.3 1.3 0 0 1 -1 2.25" }),
    /* @__PURE__ */ e("path", { d: "M8.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" }),
    /* @__PURE__ */ e("path", { d: "M12.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" }),
    /* @__PURE__ */ e("path", { d: "M16.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" })
  ] }));
}
function Zn(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M5 12l5 5l10 -10" })
  ] }));
}
function el(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M9 15l6 -6" }),
    /* @__PURE__ */ e("path", { d: "M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464" }),
    /* @__PURE__ */ e("path", { d: "M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463" })
  ] }));
}
function tl(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6" }),
    /* @__PURE__ */ e("path", { d: "M11 13l9 -9" }),
    /* @__PURE__ */ e("path", { d: "M15 4h5v5" })
  ] }));
}
function nl(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M9 14l-4 -4l4 -4" }),
    /* @__PURE__ */ e("path", { d: "M5 10h11a4 4 0 1 1 0 8h-1" })
  ] }));
}
function ll(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M15 14l4 -4l-4 -4" }),
    /* @__PURE__ */ e("path", { d: "M19 10h-11a4 4 0 1 0 0 8h1" })
  ] }));
}
function al(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M3.5 5.5l1.5 1.5l2.5 -2.5" }),
    /* @__PURE__ */ e("path", { d: "M3.5 11.5l1.5 1.5l2.5 -2.5" }),
    /* @__PURE__ */ e("path", { d: "M3.5 17.5l1.5 1.5l2.5 -2.5" }),
    /* @__PURE__ */ e("path", { d: "M11 6l9 0" }),
    /* @__PURE__ */ e("path", { d: "M11 12l9 0" }),
    /* @__PURE__ */ e("path", { d: "M11 18l9 0" })
  ] }));
}
function ol(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M20 6l-11 0" }),
    /* @__PURE__ */ e("path", { d: "M20 12l-7 0" }),
    /* @__PURE__ */ e("path", { d: "M20 18l-11 0" }),
    /* @__PURE__ */ e("path", { d: "M4 8l4 4l-4 4" })
  ] }));
}
function il(n) {
  return /* @__PURE__ */ a(y, s(l({}, n), { children: [
    /* @__PURE__ */ e("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M20 6l-7 0" }),
    /* @__PURE__ */ e("path", { d: "M20 12l-9 0" }),
    /* @__PURE__ */ e("path", { d: "M20 18l-7 0" }),
    /* @__PURE__ */ e("path", { d: "M8 8l-4 4l4 4" })
  ] }));
}
const rl = {
  interactive: !0
}, oe = q((n, r) => {
  const F = U("RichTextEditorControl", rl, n), {
    classNames: p,
    className: g,
    style: C,
    styles: f,
    vars: u,
    interactive: v,
    active: M,
    onMouseDown: b,
    disabled: m
  } = F, L = P(F, [
    "classNames",
    "className",
    "style",
    "styles",
    "vars",
    "interactive",
    "active",
    "onMouseDown",
    "disabled"
  ]), k = J();
  return /* @__PURE__ */ e(
    st,
    s(l(l({}, L), k.getStyles("control", { className: g, style: C, classNames: p, styles: f })), {
      disabled: m,
      "data-rich-text-editor-control": !0,
      tabIndex: v ? 0 : -1,
      "data-interactive": v || void 0,
      "data-disabled": m || void 0,
      "data-active": M || void 0,
      "aria-pressed": M && v || void 0,
      "aria-hidden": !v || void 0,
      ref: r,
      unstyled: k.unstyled,
      variant: k.variant || "default",
      onMouseDown: (H) => {
        H.preventDefault(), b == null || b(H);
      }
    })
  );
});
oe.classes = ee;
oe.displayName = "@mantine/tiptap/RichTextEditorControl";
const Fe = ue((g, p) => {
  var C = g, { className: n, icon: r } = C, c = P(C, ["className", "icon"]);
  const f = J();
  return /* @__PURE__ */ e(oe, s(l({ ref: p }, c), { children: /* @__PURE__ */ e(r, l({}, f.getStyles("controlIcon"))) }));
});
Fe.displayName = "@mantine/tiptap/RichTextEditorControlBase";
function S({
  label: n,
  isActive: r,
  operation: c,
  icon: p,
  isDisabled: g
}) {
  const C = ue((f, u) => {
    const { editor: v, labels: M } = J(), b = M[n];
    return /* @__PURE__ */ e(
      Fe,
      s(l({}, f), {
        "aria-label": b,
        title: b,
        active: r != null && r.name ? v == null ? void 0 : v.isActive(r.name, r.attributes) : !1,
        ref: u,
        onClick: () => v == null ? void 0 : v.chain().focus()[c.name](c.attributes).run(),
        icon: f.icon || p,
        disabled: (g == null ? void 0 : g(v)) || !1
      })
    );
  });
  return C.displayName = `@mantine/tiptap/${n}`, C;
}
const cl = S({
  label: "boldControlLabel",
  icon: (n) => /* @__PURE__ */ e(In, l({}, n)),
  isActive: { name: "bold" },
  operation: { name: "toggleBold" }
}), sl = S({
  label: "italicControlLabel",
  icon: (n) => /* @__PURE__ */ e(Tn, l({}, n)),
  isActive: { name: "italic" },
  operation: { name: "toggleItalic" }
}), hl = S({
  label: "underlineControlLabel",
  icon: (n) => /* @__PURE__ */ e(Fn, l({}, n)),
  isActive: { name: "underline" },
  operation: { name: "toggleUnderline" }
}), dl = S({
  label: "strikeControlLabel",
  icon: (n) => /* @__PURE__ */ e(Hn, l({}, n)),
  isActive: { name: "strike" },
  operation: { name: "toggleStrike" }
}), pl = S({
  label: "clearFormattingControlLabel",
  icon: (n) => /* @__PURE__ */ e(wn, l({}, n)),
  operation: { name: "unsetAllMarks" }
}), ul = S({
  label: "unlinkControlLabel",
  icon: (n) => /* @__PURE__ */ e($n, l({}, n)),
  operation: { name: "unsetLink" }
}), ml = S({
  label: "bulletListControlLabel",
  icon: (n) => /* @__PURE__ */ e(Dn, l({}, n)),
  isActive: { name: "bulletList" },
  operation: { name: "toggleBulletList" }
}), fl = S({
  label: "orderedListControlLabel",
  icon: (n) => /* @__PURE__ */ e(Un, l({}, n)),
  isActive: { name: "orderedList" },
  operation: { name: "toggleOrderedList" }
}), gl = S({
  label: "h1ControlLabel",
  icon: (n) => /* @__PURE__ */ e(zn, l({}, n)),
  isActive: { name: "heading", attributes: { level: 1 } },
  operation: { name: "toggleHeading", attributes: { level: 1 } }
}), Cl = S({
  label: "h2ControlLabel",
  icon: (n) => /* @__PURE__ */ e(Bn, l({}, n)),
  isActive: { name: "heading", attributes: { level: 2 } },
  operation: { name: "toggleHeading", attributes: { level: 2 } }
}), bl = S({
  label: "h3ControlLabel",
  icon: (n) => /* @__PURE__ */ e(Rn, l({}, n)),
  isActive: { name: "heading", attributes: { level: 3 } },
  operation: { name: "toggleHeading", attributes: { level: 3 } }
}), vl = S({
  label: "h4ControlLabel",
  icon: (n) => /* @__PURE__ */ e(Pn, l({}, n)),
  isActive: { name: "heading", attributes: { level: 4 } },
  operation: { name: "toggleHeading", attributes: { level: 4 } }
}), kl = S({
  label: "h5ControlLabel",
  icon: (n) => /* @__PURE__ */ e(En, l({}, n)),
  isActive: { name: "heading", attributes: { level: 5 } },
  operation: { name: "toggleHeading", attributes: { level: 5 } }
}), yl = S({
  label: "h6ControlLabel",
  icon: (n) => /* @__PURE__ */ e(Nn, l({}, n)),
  isActive: { name: "heading", attributes: { level: 6 } },
  operation: { name: "toggleHeading", attributes: { level: 6 } }
}), Ml = S({
  label: "blockquoteControlLabel",
  icon: (n) => /* @__PURE__ */ e(_n, l({}, n)),
  isActive: { name: "blockquote" },
  operation: { name: "toggleBlockquote" }
}), Ll = S({
  label: "alignLeftControlLabel",
  icon: (n) => /* @__PURE__ */ e(Gn, l({}, n)),
  operation: { name: "setTextAlign", attributes: "left" }
}), Al = S({
  label: "alignRightControlLabel",
  icon: (n) => /* @__PURE__ */ e(jn, l({}, n)),
  operation: { name: "setTextAlign", attributes: "right" }
}), xl = S({
  label: "alignCenterControlLabel",
  icon: (n) => /* @__PURE__ */ e(On, l({}, n)),
  operation: { name: "setTextAlign", attributes: "center" }
}), Sl = S({
  label: "alignJustifyControlLabel",
  icon: (n) => /* @__PURE__ */ e(qn, l({}, n)),
  operation: { name: "setTextAlign", attributes: "justify" }
}), Il = S({
  label: "subscriptControlLabel",
  icon: (n) => /* @__PURE__ */ e(Jn, l({}, n)),
  isActive: { name: "subscript" },
  operation: { name: "toggleSubscript" }
}), Tl = S({
  label: "superscriptControlLabel",
  icon: (n) => /* @__PURE__ */ e(Wn, l({}, n)),
  isActive: { name: "superscript" },
  operation: { name: "toggleSuperscript" }
}), Fl = S({
  label: "codeControlLabel",
  icon: (n) => /* @__PURE__ */ e(mt, l({}, n)),
  isActive: { name: "code" },
  operation: { name: "toggleCode" }
}), Hl = S({
  label: "codeBlockControlLabel",
  icon: (n) => /* @__PURE__ */ e(mt, l({}, n)),
  isActive: { name: "codeBlock" },
  operation: { name: "toggleCodeBlock" }
}), wl = S({
  label: "highlightControlLabel",
  icon: (n) => /* @__PURE__ */ e(Kn, l({}, n)),
  isActive: { name: "highlight" },
  operation: { name: "toggleHighlight" }
}), zl = S({
  label: "hrControlLabel",
  icon: (n) => /* @__PURE__ */ e(Xn, l({}, n)),
  operation: { name: "setHorizontalRule" }
}), Bl = S({
  label: "unsetColorControlLabel",
  icon: (n) => /* @__PURE__ */ e(ft, l({}, n)),
  operation: { name: "unsetColor" }
}), Rl = S({
  label: "undoControlLabel",
  icon: (n) => /* @__PURE__ */ e(nl, l({}, n)),
  isDisabled: (n) => !(n != null && n.can().undo()),
  operation: { name: "undo" }
}), Pl = S({
  label: "redoControlLabel",
  icon: (n) => /* @__PURE__ */ e(ll, l({}, n)),
  isDisabled: (n) => !(n != null && n.can().redo()),
  operation: { name: "redo" }
}), El = S({
  label: "tasksControlLabel",
  icon: (n) => /* @__PURE__ */ e(al, l({}, n)),
  isActive: { name: "taskList" },
  operation: { name: "toggleTaskList" }
}), Nl = S({
  label: "tasksSinkLabel",
  icon: (n) => /* @__PURE__ */ e(ol, l({}, n)),
  operation: { name: "sinkListItem", attributes: "taskItem" },
  isDisabled: (n) => !(n != null && n.can().sinkListItem("taskItem"))
}), Dl = S({
  label: "tasksLiftLabel",
  icon: (n) => /* @__PURE__ */ e(il, l({}, n)),
  operation: { name: "liftListItem", attributes: "taskItem" },
  isDisabled: (n) => !(n != null && n.can().liftListItem("taskItem"))
}), Ul = (n) => /* @__PURE__ */ e(el, l({}, n)), $l = {}, He = q(
  (n, r) => {
    var re;
    const c = U("RichTextEditorLinkControl", $l, n), fe = c, {
      classNames: p,
      className: g,
      style: C,
      styles: f,
      vars: u,
      icon: v,
      popoverProps: M,
      disableTooltips: b,
      initialExternal: m
    } = fe, L = P(fe, [
      "classNames",
      "className",
      "style",
      "styles",
      "vars",
      "icon",
      "popoverProps",
      "disableTooltips",
      "initialExternal"
    ]), k = J(), F = { classNames: p, styles: f }, [H, z] = gn(""), [$, t] = D(m), [te, { open: B, close: G }] = ht(!1), V = () => {
      var Y;
      B();
      const A = (Y = k.editor) == null ? void 0 : Y.getAttributes("link");
      z((A == null ? void 0 : A.href) || ""), t(A != null && A.href ? (A == null ? void 0 : A.target) === "_blank" : m);
    }, j = () => {
      G(), z(""), t(m);
    }, W = () => {
      var A, Y;
      j(), H === "" ? (A = k.editor) == null || A.chain().focus().extendMarkRange("link").unsetLink().run() : (Y = k.editor) == null || Y.chain().focus().extendMarkRange("link").setLink({ href: H, target: $ ? "_blank" : null }).run();
    }, ie = (A) => {
      A.key === "Enter" && (A.preventDefault(), W());
    };
    sn("edit-link", V, !1);
    const { resolvedClassNames: Q, resolvedStyles: me } = hn({ classNames: p, styles: f, props: c });
    return /* @__PURE__ */ a(
      le,
      s(l({
        trapFocus: !0,
        shadow: "md",
        withinPortal: !0,
        opened: te,
        onChange: (A) => !A && j(),
        offset: -44,
        zIndex: 1e4
      }, M), {
        children: [
          /* @__PURE__ */ e(le.Target, { children: /* @__PURE__ */ e(
            Fe,
            s(l({
              icon: v || Ul
            }, L), {
              "aria-label": k.labels.linkControlLabel,
              title: k.labels.linkControlLabel,
              onClick: V,
              active: (re = k.editor) == null ? void 0 : re.isActive("link"),
              ref: r,
              classNames: Q,
              styles: me,
              className: g,
              style: C,
              variant: k.variant
            })
          ) }),
          /* @__PURE__ */ e(le.Dropdown, s(l({}, k.getStyles("linkEditorDropdown", F)), { children: /* @__PURE__ */ a("div", s(l({}, k.getStyles("linkEditor", F)), { children: [
            /* @__PURE__ */ e(
              Se,
              {
                placeholder: k.labels.linkEditorInputPlaceholder,
                "aria-label": k.labels.linkEditorInputLabel,
                type: "url",
                value: H,
                onChange: z,
                classNames: { input: k.getStyles("linkEditorInput", F).className },
                onKeyDown: ie,
                rightSection: /* @__PURE__ */ e(
                  it,
                  {
                    label: $ ? k.labels.linkEditorExternalLink : k.labels.linkEditorInternalLink,
                    events: { hover: !0, focus: !0, touch: !0 },
                    withinPortal: !0,
                    withArrow: !0,
                    disabled: b,
                    zIndex: 1e4,
                    children: /* @__PURE__ */ e(
                      st,
                      s(l({
                        onClick: () => t((A) => !A),
                        "data-active": $ || void 0
                      }, k.getStyles("linkEditorExternalControl", F)), {
                        children: /* @__PURE__ */ e(tl, { style: { width: E(14), height: E(14) } })
                      })
                    )
                  }
                )
              }
            ),
            /* @__PURE__ */ e(
              dn,
              s(l({
                variant: "default",
                onClick: W
              }, k.getStyles("linkEditorSave", F)), {
                children: k.labels.linkEditorSave
              })
            )
          ] })) }))
        ]
      })
    );
  }
);
He.classes = ee;
He.displayName = "@mantine/tiptap/RichTextEditorLinkControl";
const _l = {}, gt = ue((n, r) => {
  const te = U(
    "RichTextEditorColorPickerControl",
    _l,
    n
  ), { popoverProps: c, colors: p, colorPickerProps: g } = te, C = P(te, ["popoverProps", "colors", "colorPickerProps"]), { editor: f, labels: u, getStyles: v, variant: M } = J(), [b, { toggle: m, close: L }] = ht(!1), [k, F] = D("palette"), H = (f == null ? void 0 : f.getAttributes("textStyle").color) || "var(--mantine-color-text)", z = (B, G = !0) => {
    (f == null ? void 0 : f.chain()).focus().setColor(B).run(), G && L();
  }, $ = () => {
    (f == null ? void 0 : f.chain()).focus().unsetColor().run(), L();
  }, t = p.map((B, G) => /* @__PURE__ */ e(
    pe,
    {
      component: "button",
      color: B,
      onClick: () => z(B),
      size: 26,
      radius: "xs",
      style: { cursor: "pointer" },
      title: u.colorPickerColorLabel(B),
      "aria-label": u.colorPickerColorLabel(B)
    },
    G
  ));
  return /* @__PURE__ */ a(
    le,
    s(l({
      opened: b,
      withinPortal: !0,
      trapFocus: !0,
      onChange: (B) => !B && L()
    }, c), {
      children: [
        /* @__PURE__ */ e(le.Target, { children: /* @__PURE__ */ e(
          oe,
          s(l({}, C), {
            variant: M,
            "aria-label": u.colorPickerControlLabel,
            title: u.colorPickerControlLabel,
            ref: r,
            onClick: m,
            children: /* @__PURE__ */ e(pe, { color: H, size: 14 })
          })
        ) }),
        /* @__PURE__ */ a(le.Dropdown, s(l({}, v("linkEditorDropdown")), { children: [
          k === "palette" && /* @__PURE__ */ e(xe, { cols: 7, spacing: 2, children: t }),
          k === "colorPicker" && /* @__PURE__ */ e(
            pn,
            l({
              defaultValue: H,
              onChange: (B) => z(B, !1)
            }, g)
          ),
          /* @__PURE__ */ e(it.Group, { closeDelay: 200, children: /* @__PURE__ */ a(mn, { justify: "flex-end", gap: "xs", mt: "sm", children: [
            k === "palette" && /* @__PURE__ */ e(
              se,
              {
                variant: "default",
                onClick: L,
                title: u.colorPickerCancel,
                "aria-label": u.colorPickerCancel,
                children: /* @__PURE__ */ e(Qn, { style: { width: E(16), height: E(16) } })
              }
            ),
            /* @__PURE__ */ e(
              se,
              {
                variant: "default",
                onClick: $,
                title: u.colorPickerClear,
                "aria-label": u.colorPickerClear,
                children: /* @__PURE__ */ e(ft, { style: { width: E(16), height: E(16) } })
              }
            ),
            k === "palette" ? /* @__PURE__ */ e(
              se,
              {
                variant: "default",
                onClick: () => F("colorPicker"),
                title: u.colorPickerColorPicker,
                "aria-label": u.colorPickerColorPicker,
                children: /* @__PURE__ */ e(Vn, { style: { width: E(16), height: E(16) } })
              }
            ) : /* @__PURE__ */ e(
              se,
              {
                variant: "default",
                onClick: () => F("palette"),
                "aria-label": u.colorPickerPalette,
                title: u.colorPickerPalette,
                children: /* @__PURE__ */ e(Yn, { style: { width: E(16), height: E(16) } })
              }
            ),
            k === "colorPicker" && /* @__PURE__ */ e(
              se,
              {
                variant: "default",
                onClick: L,
                title: u.colorPickerSave,
                "aria-label": u.colorPickerSave,
                children: /* @__PURE__ */ e(Zn, { style: { width: E(16), height: E(16) } })
              }
            )
          ] }) })
        ] }))
      ]
    })
  );
});
gt.displayName = "@mantine/tiptap/ColorPickerControl";
const Gl = {}, Ct = ue((n, r) => {
  const M = U("RichTextEditorColorControl", Gl, n), { color: c } = M, p = P(M, ["color"]), { editor: g, labels: C, variant: f } = J(), u = (g == null ? void 0 : g.getAttributes("textStyle").color) || null, v = C.colorControlLabel(c);
  return /* @__PURE__ */ e(
    oe,
    s(l({}, p), {
      variant: f,
      active: u === c,
      "aria-label": v,
      title: v,
      onClick: () => (g == null ? void 0 : g.chain()).focus().setColor(c).run(),
      ref: r,
      children: /* @__PURE__ */ e(pe, { color: c, size: 14 })
    })
  );
});
Ct.displayName = "@mantine/tiptap/RichTextEditorColorControl";
const jl = {}, we = q(
  (n, r) => {
    const m = U("RichTextEditorControlsGroup", jl, n), { classNames: p, className: g, style: C, styles: f, vars: u, variant: v } = m, M = P(m, ["classNames", "className", "style", "styles", "vars", "variant"]), b = J();
    return /* @__PURE__ */ e(
      X,
      l(l({
        ref: r,
        variant: v || b.variant
      }, b.getStyles("controlsGroup", { className: g, style: C, styles: f, classNames: p })), M)
    );
  }
);
we.classes = ee;
we.displayName = "@mantine/tiptap/RichTextEditorControlsGroup";
const Ol = {}, ze = q((n, r) => {
  const F = U("RichTextEditorToolbar", Ol, n), {
    classNames: p,
    className: g,
    style: C,
    styles: f,
    vars: u,
    sticky: v,
    stickyOffset: M,
    mod: b,
    variant: m
  } = F, L = P(F, [
    "classNames",
    "className",
    "style",
    "styles",
    "vars",
    "sticky",
    "stickyOffset",
    "mod",
    "variant"
  ]), k = J();
  return /* @__PURE__ */ e(
    X,
    s(l(l({
      ref: r,
      mod: [{ sticky: v }, b],
      variant: m || k.variant
    }, k.getStyles("toolbar", { className: g, style: C, styles: f, classNames: p })), L), {
      __vars: { "--rte-sticky-offset": E(M) }
    })
  );
});
ze.classes = ee;
ze.displayName = "@mantine/tiptap/RichTextEditorToolbar";
const ql = {
  withCodeHighlightStyles: !0,
  withTypographyStyles: !0,
  variant: "default"
}, h = q((n, r) => {
  const c = U("RichTextEditor", ql, n), t = c, {
    classNames: p,
    className: g,
    style: C,
    styles: f,
    unstyled: u,
    vars: v,
    editor: M,
    withCodeHighlightStyles: b,
    withTypographyStyles: m,
    labels: L,
    children: k,
    variant: F
  } = t, H = P(t, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "editor",
    "withCodeHighlightStyles",
    "withTypographyStyles",
    "labels",
    "children",
    "variant"
  ]), z = Ae({
    name: "RichTextEditor",
    classes: ee,
    props: c,
    className: g,
    style: C,
    classNames: p,
    styles: f,
    unstyled: u,
    vars: v
  }), $ = At(() => l(l({}, An), L), [L]);
  return /* @__PURE__ */ e(
    xn,
    {
      value: {
        editor: M,
        getStyles: z,
        labels: $,
        withCodeHighlightStyles: b,
        withTypographyStyles: m,
        unstyled: u,
        variant: F
      },
      children: /* @__PURE__ */ e(X, s(l(l({}, z("root")), H), { ref: r, children: k }))
    }
  );
});
h.classes = ee;
h.displayName = "@mantine/tiptap/RichTextEditor";
h.Content = Te;
h.Control = oe;
h.Toolbar = ze;
h.ControlsGroup = we;
h.Bold = cl;
h.Italic = sl;
h.Strikethrough = dl;
h.Underline = hl;
h.ClearFormatting = pl;
h.H1 = gl;
h.H2 = Cl;
h.H3 = bl;
h.H4 = vl;
h.H5 = kl;
h.H6 = yl;
h.BulletList = ml;
h.OrderedList = fl;
h.Link = He;
h.Unlink = ul;
h.Blockquote = Ml;
h.AlignLeft = Ll;
h.AlignRight = Al;
h.AlignCenter = xl;
h.AlignJustify = Sl;
h.Superscript = Tl;
h.Subscript = Il;
h.Code = Fl;
h.CodeBlock = Hl;
h.ColorPicker = gt;
h.Color = Ct;
h.Highlight = wl;
h.Hr = zl;
h.UnsetColor = Bl;
h.Undo = Rl;
h.Redo = Pl;
h.TaskList = El;
h.TaskListSink = Nl;
h.TaskListLift = Dl;
const at = "Arial", Jl = "16px", Wl = [
  "auto",
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "24px",
  "30px",
  "36px",
  "48px",
  "60px",
  "72px"
], Kl = [
  "Arial",
  "Arial Black",
  "Comic Sans MS",
  "Courier New",
  "Georgia",
  "Helvetica",
  "Helvetica Neue",
  "Impact",
  "Lucida Grande",
  "Roboto",
  "Tahoma",
  "Times New Roman",
  "Verdana"
], ot = [
  // Monochrome
  "#000000",
  // Black
  "#34495E",
  // Wet Asphalt
  "#808080",
  // Gray
  "#C0C0C0",
  // Silver
  "#ECF0F1",
  // Clouds
  "#FFFFFF",
  // White
  // Reds
  "#FF0000",
  // Pure Red
  "#F44336",
  // Material Red
  "#E74C3C",
  // Alizarin
  "#800000",
  // Maroon
  "#FF5722",
  // Material Deep Orange
  "#FF4500",
  // Reddit Orange
  "#795548",
  // Material Brown
  // Oranges & Browns
  "#FFA500",
  // Orange
  "#FF9800",
  // Material Orange
  "#F1C40F",
  // Sun Flower
  "#FFC107",
  // Material Amber
  "#808000",
  // Olive
  "#CDDC39",
  // Lime
  "#8BC34A",
  // Light Green
  // Greens
  "#00FF00",
  // Pure Green
  "#4CAF50",
  // Material Green
  "#2ECC71",
  // Emerald
  "#008000",
  // Green
  "#00B388",
  // Spotify Green
  "#1ABC9C",
  // Turquoise
  "#008080",
  // Teal
  // Cyans & Light Blues
  "#00BCD4",
  // Cyan
  "#03A9F4",
  // Light Blue
  "#1DA1F2",
  // Twitter Blue
  "#2196F3",
  // Material Blue
  "#3498DB",
  // Peter River
  "#4267B2",
  // Facebook Blue
  "#7289DA",
  // Discord Blue
  // Blues & Navy
  "#0000FF",
  // Pure Blue
  "#000080",
  // Navy
  "#1864AB",
  // Deep Blue
  "#6441A5",
  // Twitch Purple
  "#673AB7",
  // Deep Purple
  "#9C27B0",
  // Material Purple
  "#800080",
  // Purple
  // Pinks & Magentas
  "#E1306C",
  // Instagram Magenta
  "#FF1493",
  // Deep Pink
  "#FF4081",
  // Accent Pink
  "#E91E63",
  // Pink
  "#9B59B6",
  // Amethyst
  "#FFFF00",
  // Yellow
  "#FF8C00"
  // Dark Orange
], Xl = [
  { value: "normal", label: "Normal" },
  { value: "1", label: "1" },
  { value: "1.15", label: "1.15" },
  { value: "1.5", label: "1.5" },
  { value: "2", label: "2" },
  { value: "2.5", label: "2.5" },
  { value: "3", label: "3" }
], Vl = ue((b, M) => {
  var m = b, {
    label: n,
    content: r = "",
    error: c,
    description: p,
    disabled: g,
    onChange: C,
    required: f,
    controls: u = {}
  } = m, v = P(m, [
    "label",
    "content",
    "error",
    "description",
    "disabled",
    "onChange",
    "required",
    "controls"
  ]);
  const [L, k] = D(!1), [F, H] = D(r), [z, $] = D(""), t = xt({
    extensions: [
      St.configure({
        heading: {
          levels: [1, 2, 3, 4, 5, 6],
          HTMLAttributes: {
            class: d.heading
          }
        },
        codeBlock: !1
        // Disable the one from StarterKit since we're configuring our own
      }),
      an.configure({
        HTMLAttributes: {
          class: d.codeBlock
        }
      }),
      Yt,
      Ht.configure({
        HTMLAttributes: {
          style: `font-family: ${at};`
        }
      }),
      wt,
      Kt.configure({ multicolor: !0 }),
      It.configure({ types: ["heading", "paragraph", "image"] }),
      Tt.configure({
        openOnClick: !1,
        HTMLAttributes: {
          class: d.link
        }
      }),
      Vt.configure({
        inline: !1,
        allowBase64: !0,
        HTMLAttributes: {
          class: d.image
        }
      }).extend({
        addAttributes() {
          var i;
          return s(l({}, (i = this.parent) == null ? void 0 : i.call(this)), {
            width: {
              default: "100%",
              renderHTML: (x) => ({
                width: x.width
              })
            },
            class: {
              default: d.image,
              parseHTML: (x) => x.getAttribute("class"),
              renderHTML: (x) => ({
                class: x.class || d.image
              })
            },
            // Add textAlign attribute
            textAlign: {
              default: "left",
              renderHTML: (x) => ({
                style: `text-align: ${x.textAlign}`
              })
            }
          });
        }
      }),
      Ft.configure({
        types: ["textStyle", "heading"]
      }),
      zt.configure({
        types: ["textStyle", "heading"]
      }),
      Zt.configure({
        types: ["paragraph", "heading"],
        defaultHeight: "normal"
      }),
      en.configure({
        resizable: !0,
        handleWidth: 4,
        cellMinWidth: 100,
        lastColumnResizable: !0,
        HTMLAttributes: {
          class: d.richTable
        }
      }),
      tn,
      nn,
      ln
    ],
    content: r,
    onUpdate: ({ editor: i }) => {
      const x = i.getHTML();
      H(x), C == null || C(x);
    },
    editable: !g
  }), te = typeof n == "string" ? /* @__PURE__ */ e(Bt, { label: n, withAsterisk: f }) : n, B = (i) => {
    const x = i.target.value;
    H(x), t == null || t.commands.setContent(x), C == null || C(x);
  }, [G, V] = D(!1), [j, W] = D(""), [ie, Q] = D(""), [me, fe] = D({ x: 0, y: 0 }), [re, A] = D(!1), Y = Ne((i) => {
    !i.target.closest("table") || !(t != null && t.can().deleteTable()) || (i.preventDefault(), fe({ x: i.clientX, y: i.clientY }), A(!0));
  }, [t]), ke = Ne((i) => {
    A(!1);
  }, []);
  De(() => (document.addEventListener("click", ke), () => {
    document.removeEventListener("click", ke);
  }), [ke]), De(() => {
    if (G) {
      const { from: i } = (t == null ? void 0 : t.state.selection) || {}, x = i !== void 0 ? t == null ? void 0 : t.state.doc.nodeAt(i) : null;
      if ((x == null ? void 0 : x.type.name) === "image")
        Q("");
      else {
        const O = t == null ? void 0 : t.state.doc.textBetween(
          t.state.selection.from,
          t.state.selection.to,
          ""
        );
        Q(O || "");
      }
      const ce = t == null ? void 0 : t.state.selection.$from.marks().find((O) => O.type.name === "link");
      W(ce && ce.attrs.href || "");
    }
  }, [G, t]);
  const bt = (i) => {
    if (i.preventDefault(), !j || !t) return;
    const { from: x } = t.state.selection, R = x !== void 0 ? t.state.doc.nodeAt(x) : null;
    if ((R == null ? void 0 : R.type.name) === "image") {
      const O = t.state.selection.$from.pos, vt = R.nodeSize, kt = `<a href="${j}" target="_blank" rel="noopener noreferrer nofollow" class="${d.link}"><img src="${R.attrs.src}" alt="${R.attrs.alt || ""}" width="${R.attrs.width || "100%"}" class="${d.image}" contenteditable="false" draggable="true"/></a>`;
      t.chain().focus().deleteRange({ from: O, to: O + vt }).insertContent(kt).run();
    } else
      ie && !t.state.selection.content().size ? t.chain().focus().insertContent(ie).setLink({
        href: j,
        target: "_blank",
        rel: "noopener noreferrer nofollow"
      }).run() : t.chain().focus().extendMarkRange("link").setLink({
        href: j,
        target: "_blank",
        rel: "noopener noreferrer nofollow"
      }).run();
    V(!1), W(""), Q("");
  }, N = (i) => {
    var x;
    return i in u && (x = u[i]) != null ? x : !0;
  };
  return /* @__PURE__ */ a("div", { className: d.root, children: [
    te,
    /* @__PURE__ */ a(
      h,
      s(l({
        ref: M,
        editor: t,
        classNames: {
          root: d.editor,
          toolbar: d.toolbar,
          content: d.content,
          control: d.control,
          controlsGroup: d.controlsGroup
        }
      }, v), {
        children: [
          /* @__PURE__ */ a(h.Toolbar, { sticky: !0, children: [
            /* @__PURE__ */ e(h.ControlsGroup, { children: /* @__PURE__ */ a(w, { gap: 4, children: [
              /* @__PURE__ */ a(w, { className: d.formatControls, children: [
                /* @__PURE__ */ a(w, { className: d.desktopControls, gap: 4, children: [
                  N("bold") && /* @__PURE__ */ e(T, { label: "Bold", children: /* @__PURE__ */ e(
                    I,
                    {
                      variant: "tertiary",
                      size: "sm",
                      onClick: () => t == null ? void 0 : t.chain().focus().toggleBold().run(),
                      "data-active": t == null ? void 0 : t.isActive("bold"),
                      "aria-label": "Bold",
                      children: /* @__PURE__ */ e($e, {})
                    }
                  ) }),
                  N("italic") && /* @__PURE__ */ e(T, { label: "Italic", children: /* @__PURE__ */ e(
                    I,
                    {
                      variant: "tertiary",
                      size: "sm",
                      onClick: () => t == null ? void 0 : t.chain().focus().toggleItalic().run(),
                      "data-active": t == null ? void 0 : t.isActive("italic"),
                      "aria-label": "Italic",
                      children: /* @__PURE__ */ e(_e, {})
                    }
                  ) }),
                  N("underline") && /* @__PURE__ */ e(T, { label: "Underline", children: /* @__PURE__ */ e(
                    I,
                    {
                      variant: "tertiary",
                      size: "sm",
                      onClick: () => t == null ? void 0 : t.chain().focus().toggleUnderline().run(),
                      "data-active": t == null ? void 0 : t.isActive("underline"),
                      "aria-label": "Underline",
                      children: /* @__PURE__ */ e(Ge, {})
                    }
                  ) }),
                  N("strike") && /* @__PURE__ */ e(T, { label: "Strikethrough", children: /* @__PURE__ */ e(
                    I,
                    {
                      variant: "tertiary",
                      size: "sm",
                      onClick: () => t == null ? void 0 : t.chain().focus().toggleStrike().run(),
                      "data-active": t == null ? void 0 : t.isActive("strike"),
                      "aria-label": "Strikethrough",
                      children: /* @__PURE__ */ e(je, {})
                    }
                  ) })
                ] }),
                /* @__PURE__ */ e(w, { className: d.mobileControls, gap: 4, children: /* @__PURE__ */ a(o, { children: [
                  /* @__PURE__ */ e(o.Target, { children: /* @__PURE__ */ a(
                    I,
                    {
                      variant: "tertiary",
                      size: "sm",
                      "aria-label": "Text formatting",
                      children: [
                        /* @__PURE__ */ e(Pt, {}),
                        /* @__PURE__ */ e(T, { label: "Text formatting", children: /* @__PURE__ */ e("div", { className: d.buttonTooltip }) })
                      ]
                    }
                  ) }),
                  /* @__PURE__ */ a(o.Dropdown, { children: [
                    N("bold") && /* @__PURE__ */ e(
                      o.Item,
                      {
                        leftSection: /* @__PURE__ */ e($e, {}),
                        onClick: () => t == null ? void 0 : t.chain().focus().toggleBold().run(),
                        "data-selected": t == null ? void 0 : t.isActive("bold"),
                        children: "Bold"
                      }
                    ),
                    N("italic") && /* @__PURE__ */ e(
                      o.Item,
                      {
                        leftSection: /* @__PURE__ */ e(_e, {}),
                        onClick: () => t == null ? void 0 : t.chain().focus().toggleItalic().run(),
                        "data-selected": t == null ? void 0 : t.isActive("italic"),
                        children: "Italic"
                      }
                    ),
                    N("underline") && /* @__PURE__ */ e(
                      o.Item,
                      {
                        leftSection: /* @__PURE__ */ e(Ge, {}),
                        onClick: () => t == null ? void 0 : t.chain().focus().toggleUnderline().run(),
                        "data-selected": t == null ? void 0 : t.isActive("underline"),
                        children: "Underline"
                      }
                    ),
                    N("strike") && /* @__PURE__ */ e(
                      o.Item,
                      {
                        leftSection: /* @__PURE__ */ e(je, {}),
                        onClick: () => t == null ? void 0 : t.chain().focus().toggleStrike().run(),
                        "data-selected": t == null ? void 0 : t.isActive("strike"),
                        children: "Strikethrough"
                      }
                    )
                  ] })
                ] }) })
              ] }),
              N("clearFormatting") && /* @__PURE__ */ e(T, { label: "Clear formatting", children: /* @__PURE__ */ e(
                I,
                {
                  variant: "tertiary",
                  size: "sm",
                  onClick: () => t == null ? void 0 : t.chain().focus().clearNodes().unsetAllMarks().run(),
                  "aria-label": "Clear formatting",
                  children: /* @__PURE__ */ e(ye, {})
                }
              ) })
            ] }) }),
            /* @__PURE__ */ e(Z, { orientation: "vertical" }),
            /* @__PURE__ */ e(T, { label: "Undo", children: /* @__PURE__ */ e(
              I,
              {
                variant: "tertiary",
                size: "sm",
                onClick: () => t == null ? void 0 : t.chain().focus().undo().run(),
                disabled: !(t != null && t.can().undo()),
                "aria-label": "Undo",
                children: /* @__PURE__ */ e(Et, {})
              }
            ) }),
            /* @__PURE__ */ e(T, { label: "Redo", children: /* @__PURE__ */ e(
              I,
              {
                variant: "tertiary",
                size: "sm",
                onClick: () => t == null ? void 0 : t.chain().focus().redo().run(),
                disabled: !(t != null && t.can().redo()),
                "aria-label": "Redo",
                children: /* @__PURE__ */ e(Nt, {})
              }
            ) }),
            /* @__PURE__ */ e(Z, { orientation: "vertical" }),
            /* @__PURE__ */ e(h.ControlsGroup, { className: d.headingControls, children: /* @__PURE__ */ a(w, { gap: 4, children: [
              /* @__PURE__ */ a(o, { styles: { dropdown: { width: "240px" } }, children: [
                /* @__PURE__ */ e(o.Target, { children: /* @__PURE__ */ a(
                  I,
                  {
                    className: d.fontFamilyButton,
                    variant: "tertiary",
                    size: "sm",
                    "data-expanded": !1,
                    "aria-label": "Font family",
                    children: [
                      /* @__PURE__ */ e("span", { className: d.fontFamilyButtonLabel, children: (t == null ? void 0 : t.getAttributes("textStyle").fontFamily) || at }),
                      /* @__PURE__ */ e(ne, { size: 10, style: { marginLeft: 2 } }),
                      /* @__PURE__ */ e(T, { label: "Font family", children: /* @__PURE__ */ e("div", { className: d.buttonTooltip }) })
                    ]
                  }
                ) }),
                /* @__PURE__ */ e(o.Dropdown, { children: Kl.map((i) => /* @__PURE__ */ e(
                  o.Item,
                  {
                    onClick: () => t == null ? void 0 : t.chain().focus().setFontFamily(i).run(),
                    "data-selected": t == null ? void 0 : t.isActive("textStyle", { fontFamily: i }),
                    style: { fontFamily: i },
                    children: i
                  },
                  i
                )) })
              ] }),
              /* @__PURE__ */ a(o, { children: [
                /* @__PURE__ */ e(o.Target, { children: /* @__PURE__ */ a(
                  I,
                  {
                    className: d.fontSizeButton,
                    variant: "tertiary",
                    size: "sm",
                    "data-expanded": !1,
                    "aria-label": "Font size",
                    children: [
                      /* @__PURE__ */ e("span", { className: d.fontSizeButtonLabel, children: t != null && t.isActive("heading") ? "auto" : (t == null ? void 0 : t.getAttributes("textStyle").fontSize) || Jl }),
                      /* @__PURE__ */ e(ne, { size: 10, style: { marginLeft: 2 } }),
                      /* @__PURE__ */ e(T, { label: "Font size", children: /* @__PURE__ */ e("div", { className: d.buttonTooltip }) })
                    ]
                  }
                ) }),
                /* @__PURE__ */ e(o.Dropdown, { children: Wl.map((i) => /* @__PURE__ */ e(
                  o.Item,
                  {
                    onClick: () => {
                      i !== "auto" && (t != null && t.isActive("heading") ? t.chain().focus().setParagraph().setMark("textStyle", { fontSize: i }).run() : t == null || t.chain().focus().setMark("textStyle", { fontSize: i }).run());
                    },
                    "data-selected": i === "auto" ? t == null ? void 0 : t.isActive("heading") : t == null ? void 0 : t.isActive("textStyle", { fontSize: i }),
                    children: i
                  },
                  i
                )) })
              ] }),
              /* @__PURE__ */ a(o, { styles: { dropdown: { width: "240px" } }, children: [
                /* @__PURE__ */ e(o.Target, { children: /* @__PURE__ */ a(
                  I,
                  {
                    variant: "tertiary",
                    size: "sm",
                    "data-expanded": !1,
                    "aria-label": "Font style",
                    children: [
                      /* @__PURE__ */ e(Dt, {}),
                      /* @__PURE__ */ e(ne, { size: 10, style: { marginLeft: 2 } }),
                      /* @__PURE__ */ e(T, { label: "Font style", children: /* @__PURE__ */ e("div", { className: d.buttonTooltip }) })
                    ]
                  }
                ) }),
                /* @__PURE__ */ a(o.Dropdown, { className: d.fontHeadingDropdown, children: [
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => t == null ? void 0 : t.chain().focus().setParagraph().run(),
                      "data-selected": t == null ? void 0 : t.isActive("paragraph"),
                      children: "Normal text"
                    }
                  ),
                  /* @__PURE__ */ e(o.Divider, {}),
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => t == null ? void 0 : t.chain().focus().toggleHeading({ level: 1 }).run(),
                      "data-selected": t == null ? void 0 : t.isActive("heading", { level: 1 }),
                      children: /* @__PURE__ */ e("span", { style: { fontSize: "2em", lineHeight: "1" }, children: "Heading 1" })
                    }
                  ),
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => t == null ? void 0 : t.chain().focus().toggleHeading({ level: 2 }).run(),
                      "data-selected": t == null ? void 0 : t.isActive("heading", { level: 2 }),
                      children: /* @__PURE__ */ e("span", { style: { fontSize: "1.5em", lineHeight: "1" }, children: "Heading 2" })
                    }
                  ),
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => t == null ? void 0 : t.chain().focus().toggleHeading({ level: 3 }).run(),
                      "data-selected": t == null ? void 0 : t.isActive("heading", { level: 3 }),
                      children: /* @__PURE__ */ e("span", { style: { fontSize: "1.17em", lineHeight: "1" }, children: "Heading 3" })
                    }
                  ),
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => t == null ? void 0 : t.chain().focus().toggleHeading({ level: 4 }).run(),
                      "data-selected": t == null ? void 0 : t.isActive("heading", { level: 4 }),
                      children: /* @__PURE__ */ e("span", { style: { fontSize: "1em", lineHeight: "1" }, children: "Heading 4" })
                    }
                  ),
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => t == null ? void 0 : t.chain().focus().toggleHeading({ level: 5 }).run(),
                      "data-selected": t == null ? void 0 : t.isActive("heading", { level: 5 }),
                      children: /* @__PURE__ */ e("span", { style: { fontSize: "0.83em", lineHeight: "1" }, children: "Heading 5" })
                    }
                  ),
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => t == null ? void 0 : t.chain().focus().toggleHeading({ level: 6 }).run(),
                      "data-selected": t == null ? void 0 : t.isActive("heading", { level: 6 }),
                      children: /* @__PURE__ */ e("span", { style: { fontSize: "0.67em", lineHeight: "1" }, children: "Heading 6" })
                    }
                  ),
                  /* @__PURE__ */ e(o.Divider, {}),
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => t == null ? void 0 : t.chain().focus().toggleBlockquote().run(),
                      "data-selected": t == null ? void 0 : t.isActive("blockquote"),
                      children: /* @__PURE__ */ e("blockquote", { style: { fontSize: "inherit", pointerEvents: "none", padding: "1rem", margin: "0", background: "#F1F3F5", borderLeft: "5px solid #D1D5DB", borderRadius: "0.5rem" }, children: "Quote" })
                    }
                  ),
                  /* @__PURE__ */ e(o.Divider, {}),
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => t == null ? void 0 : t.chain().focus().toggleCode().run(),
                      "data-selected": t == null ? void 0 : t.isActive("code"),
                      children: /* @__PURE__ */ e("code", { style: { fontSize: "inherit", pointerEvents: "none", padding: "0.25rem", margin: "0", background: "#F1F3F5", borderRadius: "0.25rem" }, children: "Code" })
                    }
                  )
                ] })
              ] }),
              /* @__PURE__ */ e(h.ControlsGroup, { children: /* @__PURE__ */ a(w, { gap: 0, children: [
                /* @__PURE__ */ a(o, { children: [
                  /* @__PURE__ */ e(o.Target, { children: /* @__PURE__ */ e(T, { label: "Font color", children: /* @__PURE__ */ e(
                    I,
                    {
                      variant: "tertiary",
                      size: "sm",
                      "data-expanded": !1,
                      "aria-label": "Font color",
                      children: /* @__PURE__ */ e(w, { align: "center", gap: 4, children: /* @__PURE__ */ e(
                        "div",
                        {
                          style: {
                            width: "14px",
                            height: "14px",
                            borderRadius: "2px",
                            backgroundColor: (t == null ? void 0 : t.getAttributes("textStyle").color) || "currentColor",
                            border: "1px solid rgba(0, 0, 0, 0.2)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                          }
                        }
                      ) })
                    }
                  ) }) }),
                  /* @__PURE__ */ a(o.Dropdown, { children: [
                    /* @__PURE__ */ e(w, { gap: "xs", wrap: "wrap", p: "xs", className: d.richColorPicker, children: /* @__PURE__ */ e("div", { className: d.richColorPickerSwatch, children: ot.map((i) => /* @__PURE__ */ e(
                      pe,
                      {
                        className: d.richColorPickerSwatch,
                        component: "button",
                        color: i,
                        onClick: () => t == null ? void 0 : t.chain().focus().setColor(i).run(),
                        style: { cursor: "pointer" },
                        size: 22
                      },
                      i
                    )) }) }),
                    /* @__PURE__ */ e(o.Divider, {}),
                    /* @__PURE__ */ e(
                      o.Item,
                      {
                        onClick: () => t == null ? void 0 : t.chain().focus().unsetColor().run(),
                        leftSection: /* @__PURE__ */ e(ye, { size: 14 }),
                        children: "Reset color"
                      }
                    )
                  ] })
                ] }),
                /* @__PURE__ */ a(o, { children: [
                  /* @__PURE__ */ e(o.Target, { children: /* @__PURE__ */ e(T, { label: "Background color", children: /* @__PURE__ */ e(
                    I,
                    {
                      variant: "tertiary",
                      size: "sm",
                      "data-expanded": !1,
                      "aria-label": "Background color",
                      children: /* @__PURE__ */ e(w, { align: "center", gap: 4, children: /* @__PURE__ */ e(
                        "div",
                        {
                          style: {
                            width: "14px",
                            height: "14px",
                            borderRadius: "2px",
                            backgroundColor: (t == null ? void 0 : t.getAttributes("highlight").color) || "transparent",
                            border: "1px solid rgba(0, 0, 0, 0.2)"
                          }
                        }
                      ) })
                    }
                  ) }) }),
                  /* @__PURE__ */ a(o.Dropdown, { children: [
                    /* @__PURE__ */ e(w, { gap: "xs", wrap: "wrap", p: "xs", children: /* @__PURE__ */ e("div", { className: d.richColorPickerSwatch, children: ot.map((i) => /* @__PURE__ */ e(
                      pe,
                      {
                        className: d.richColorPickerSwatch,
                        component: "button",
                        color: i,
                        onClick: () => t == null ? void 0 : t.chain().focus().setHighlight({ color: i }).run(),
                        style: { cursor: "pointer" },
                        size: 22
                      },
                      i
                    )) }) }),
                    /* @__PURE__ */ e(o.Divider, {}),
                    /* @__PURE__ */ e(
                      o.Item,
                      {
                        onClick: () => t == null ? void 0 : t.chain().focus().unsetHighlight().run(),
                        leftSection: /* @__PURE__ */ e(ye, { size: 14 }),
                        children: "Reset background"
                      }
                    )
                  ] })
                ] })
              ] }) })
            ] }) }),
            /* @__PURE__ */ e(Z, { orientation: "vertical" }),
            /* @__PURE__ */ e(h.ControlsGroup, { children: /* @__PURE__ */ a(w, { gap: 4, children: [
              /* @__PURE__ */ a(o, { children: [
                /* @__PURE__ */ e(o.Target, { children: /* @__PURE__ */ a(
                  I,
                  {
                    variant: "tertiary",
                    size: "sm",
                    "data-expanded": !1,
                    "aria-label": "Text alignment",
                    children: [
                      t != null && t.isActive({ textAlign: "left" }) ? /* @__PURE__ */ e(Me, {}) : t != null && t.isActive({ textAlign: "center" }) ? /* @__PURE__ */ e(Oe, {}) : t != null && t.isActive({ textAlign: "right" }) ? /* @__PURE__ */ e(qe, {}) : t != null && t.isActive({ textAlign: "justify" }) ? /* @__PURE__ */ e(Je, {}) : /* @__PURE__ */ e(Me, {}),
                      /* @__PURE__ */ e(ne, { size: 10, style: { marginLeft: 2 } }),
                      /* @__PURE__ */ e(T, { label: "Text alignment", children: /* @__PURE__ */ e("div", { className: d.buttonTooltip }) })
                    ]
                  }
                ) }),
                /* @__PURE__ */ a(o.Dropdown, { children: [
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      leftSection: /* @__PURE__ */ e(Me, {}),
                      onClick: () => t == null ? void 0 : t.chain().focus().setTextAlign("left").run(),
                      "data-selected": t == null ? void 0 : t.isActive({ textAlign: "left" }),
                      children: "Left"
                    }
                  ),
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      leftSection: /* @__PURE__ */ e(Oe, {}),
                      onClick: () => t == null ? void 0 : t.chain().focus().setTextAlign("center").run(),
                      "data-selected": t == null ? void 0 : t.isActive({ textAlign: "center" }),
                      children: "Center"
                    }
                  ),
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      leftSection: /* @__PURE__ */ e(qe, {}),
                      onClick: () => t == null ? void 0 : t.chain().focus().setTextAlign("right").run(),
                      "data-selected": t == null ? void 0 : t.isActive({ textAlign: "right" }),
                      children: "Right"
                    }
                  ),
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      leftSection: /* @__PURE__ */ e(Je, {}),
                      onClick: () => t == null ? void 0 : t.chain().focus().setTextAlign("justify").run(),
                      "data-selected": t == null ? void 0 : t.isActive({ textAlign: "justify" }),
                      children: "Justify"
                    }
                  )
                ] })
              ] }),
              /* @__PURE__ */ a(o, { children: [
                /* @__PURE__ */ e(o.Target, { children: /* @__PURE__ */ a(
                  I,
                  {
                    variant: "tertiary",
                    size: "sm",
                    className: d.lineHeightButton,
                    "data-expanded": !1,
                    "aria-label": "Line height",
                    children: [
                      /* @__PURE__ */ e(Ut, {}),
                      /* @__PURE__ */ e(ne, { size: 10, style: { marginLeft: 2 } }),
                      /* @__PURE__ */ e(T, { label: "Line height", children: /* @__PURE__ */ e("div", { className: d.buttonTooltip }) })
                    ]
                  }
                ) }),
                /* @__PURE__ */ e(o.Dropdown, { children: Xl.map((i) => /* @__PURE__ */ e(
                  o.Item,
                  {
                    onClick: () => {
                      t == null || t.chain().focus().setLineHeight(i.value).run();
                    },
                    "data-selected": (t == null ? void 0 : t.isActive("paragraph", { lineHeight: i.value })) || (t == null ? void 0 : t.isActive("heading", { lineHeight: i.value })),
                    children: i.label
                  },
                  i.value
                )) })
              ] }),
              N("bulletList") && /* @__PURE__ */ e(T, { label: "Bullet list", children: /* @__PURE__ */ e(
                I,
                {
                  variant: "tertiary",
                  size: "sm",
                  onClick: () => t == null ? void 0 : t.chain().focus().toggleBulletList().run(),
                  "data-active": t == null ? void 0 : t.isActive("bulletList"),
                  "aria-label": "Bullet list",
                  children: /* @__PURE__ */ e($t, {})
                }
              ) }),
              N("orderedList") && /* @__PURE__ */ e(T, { label: "Numbered list", children: /* @__PURE__ */ e(
                I,
                {
                  variant: "tertiary",
                  size: "sm",
                  onClick: () => t == null ? void 0 : t.chain().focus().toggleOrderedList().run(),
                  "data-active": t == null ? void 0 : t.isActive("orderedList"),
                  "aria-label": "Numbered list",
                  children: /* @__PURE__ */ e(_t, {})
                }
              ) })
            ] }) }),
            /* @__PURE__ */ e(Z, { orientation: "vertical" }),
            /* @__PURE__ */ e(h.ControlsGroup, { children: /* @__PURE__ */ a(w, { gap: 4, children: [
              /* @__PURE__ */ a(o, { opened: G, onChange: V, children: [
                /* @__PURE__ */ e(o.Target, { children: /* @__PURE__ */ a(
                  I,
                  {
                    variant: "tertiary",
                    size: "sm",
                    onClick: () => {
                      t != null && t.isActive("link") ? t.chain().focus().unsetLink().run() : V(!0);
                    },
                    "data-active": t == null ? void 0 : t.isActive("link"),
                    "aria-label": t != null && t.isActive("link") ? "Remove link" : "Add link",
                    children: [
                      t != null && t.isActive("link") ? /* @__PURE__ */ e(Gt, {}) : /* @__PURE__ */ e(jt, {}),
                      /* @__PURE__ */ e(T, { label: t != null && t.isActive("link") ? "Remove link" : "Add link", children: /* @__PURE__ */ e("div", { className: d.buttonTooltip }) })
                    ]
                  }
                ) }),
                /* @__PURE__ */ e(o.Dropdown, { className: d.linkMenu, children: /* @__PURE__ */ a(he, { p: "xs", children: [
                  !(t != null && t.isActive("image")) && /* @__PURE__ */ e(
                    be,
                    {
                      label: "Text",
                      value: ie,
                      onChange: (i) => Q(i.target.value)
                    }
                  ),
                  /* @__PURE__ */ e(
                    be,
                    {
                      label: "URL",
                      value: j,
                      onChange: (i) => W(i.target.value)
                    }
                  ),
                  /* @__PURE__ */ a(w, { gap: "xs", justify: "flex-end", children: [
                    /* @__PURE__ */ e(
                      I,
                      {
                        variant: "tertiary",
                        size: "sm",
                        onClick: () => {
                          V(!1), W(""), Q("");
                        },
                        children: "Cancel"
                      }
                    ),
                    /* @__PURE__ */ e(
                      I,
                      {
                        variant: "primary",
                        size: "sm",
                        onClick: bt,
                        disabled: !j,
                        children: "Save"
                      }
                    )
                  ] })
                ] }) })
              ] }),
              /* @__PURE__ */ a(o, { classNames: { dropdown: d.imageMenu }, children: [
                /* @__PURE__ */ e(o.Target, { children: /* @__PURE__ */ a(
                  I,
                  {
                    variant: "tertiary",
                    size: "sm",
                    "aria-label": "Add image",
                    children: [
                      /* @__PURE__ */ e(Ot, {}),
                      /* @__PURE__ */ e(T, { label: "Add image", children: /* @__PURE__ */ e("div", { className: d.buttonTooltip }) })
                    ]
                  }
                ) }),
                /* @__PURE__ */ e(o.Dropdown, { children: /* @__PURE__ */ a(he, { p: "xs", children: [
                  /* @__PURE__ */ e(
                    Xt,
                    {
                      onDrop: (i) => {
                        const x = i[0];
                        if (x) {
                          const R = URL.createObjectURL(x);
                          t == null || t.chain().focus().insertContent(`<p><img src="${R}" alt="${x.name}" width="50%" class="${d.image}"></p>`).run();
                        }
                      },
                      maxSize: 5 * Ee(1024, 2),
                      accept: {
                        "image/*": [".png", ".jpg", ".jpeg", ".gif", ".webp"]
                      },
                      description: "PNG, JPG, GIF, WebP (max 5MB)",
                      title: "Upload image"
                    }
                  ),
                  /* @__PURE__ */ a(w, { gap: "xs", align: "center", children: [
                    /* @__PURE__ */ e(Z, { w: "100%" }),
                    /* @__PURE__ */ e(de, { size: "sm", c: "gray.7", children: "or" }),
                    /* @__PURE__ */ e(Z, { w: "100%" })
                  ] }),
                  /* @__PURE__ */ a(he, { w: "100%", gap: "xs", children: [
                    /* @__PURE__ */ e(
                      be,
                      {
                        w: "100%",
                        label: "Image URL",
                        value: z,
                        onChange: (i) => $(i.target.value),
                        placeholder: "https://example.com/image.png"
                      }
                    ),
                    z && /* @__PURE__ */ e(
                      I,
                      {
                        onClick: () => {
                          t == null || t.chain().focus().insertContent(`<p><img src="${z}" alt="Image" width="50%" class="${d.image}"></p>`).run(), $("");
                        },
                        variant: "primary",
                        size: "sm",
                        leftSection: /* @__PURE__ */ e(We, {}),
                        children: "Insert"
                      }
                    )
                  ] })
                ] }) })
              ] })
            ] }) }),
            /* @__PURE__ */ e(h.ControlsGroup, { children: /* @__PURE__ */ e(w, { gap: 4, children: t != null && t.can().deleteTable() ? /* @__PURE__ */ a(o, { children: [
              /* @__PURE__ */ e(o.Target, { children: /* @__PURE__ */ a(
                I,
                {
                  variant: "tertiary",
                  size: "sm",
                  "aria-label": "Table",
                  onClick: () => A(!1),
                  children: [
                    /* @__PURE__ */ e(Ke, {}),
                    /* @__PURE__ */ e(ne, { size: 10, style: { marginLeft: 2 } }),
                    /* @__PURE__ */ e(T, { label: "Table options", children: /* @__PURE__ */ e("div", { className: d.buttonTooltip }) })
                  ]
                }
              ) }),
              /* @__PURE__ */ a(o.Dropdown, { classNames: { dropdown: d.tableMenu }, children: [
                (t == null ? void 0 : t.can().addColumnBefore()) && /* @__PURE__ */ a(_, { children: [
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => t == null ? void 0 : t.chain().focus().addColumnBefore().run(),
                      leftSection: /* @__PURE__ */ e(Xe, {}),
                      children: "Add column to left"
                    }
                  ),
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => t == null ? void 0 : t.chain().focus().addColumnAfter().run(),
                      leftSection: /* @__PURE__ */ e(Ve, {}),
                      children: "Add column to right"
                    }
                  ),
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => t == null ? void 0 : t.chain().focus().deleteColumn().run(),
                      leftSection: /* @__PURE__ */ e(Ce, {}),
                      children: "Delete column"
                    }
                  )
                ] }),
                (t == null ? void 0 : t.can().addRowBefore()) && /* @__PURE__ */ a(_, { children: [
                  /* @__PURE__ */ e(o.Divider, {}),
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => t == null ? void 0 : t.chain().focus().addRowBefore().run(),
                      leftSection: /* @__PURE__ */ e(Qe, {}),
                      children: "Add row above"
                    }
                  ),
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => t == null ? void 0 : t.chain().focus().addRowAfter().run(),
                      leftSection: /* @__PURE__ */ e(Ye, {}),
                      children: "Add row below"
                    }
                  ),
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => t == null ? void 0 : t.chain().focus().deleteRow().run(),
                      leftSection: /* @__PURE__ */ e(Ce, {}),
                      children: "Delete row"
                    }
                  )
                ] }),
                (t == null ? void 0 : t.can().mergeCells()) && /* @__PURE__ */ a(_, { children: [
                  /* @__PURE__ */ e(o.Divider, {}),
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => t == null ? void 0 : t.chain().focus().mergeCells().run(),
                      leftSection: /* @__PURE__ */ e(Ze, {}),
                      children: "Merge cells"
                    }
                  ),
                  (t == null ? void 0 : t.can().splitCell()) && /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => t == null ? void 0 : t.chain().focus().splitCell().run(),
                      leftSection: /* @__PURE__ */ e(et, {}),
                      children: "Split cell"
                    }
                  ),
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => t == null ? void 0 : t.chain().focus().toggleHeaderCell().run(),
                      leftSection: /* @__PURE__ */ e(tt, {}),
                      children: t != null && t.isActive("tableHeader") ? "Remove header cell" : "Make header cell"
                    }
                  )
                ] }),
                /* @__PURE__ */ e(o.Divider, {}),
                /* @__PURE__ */ e(
                  o.Item,
                  {
                    "data-danger": !0,
                    onClick: () => t == null ? void 0 : t.chain().focus().deleteTable().run(),
                    leftSection: /* @__PURE__ */ e(nt, {}),
                    children: "Delete table"
                  }
                )
              ] })
            ] }) : /* @__PURE__ */ e(T, { label: "Add table", children: /* @__PURE__ */ e(
              I,
              {
                variant: "tertiary",
                size: "sm",
                onClick: () => t == null ? void 0 : t.chain().focus().insertTable({ rows: 3, cols: 3 }).run(),
                "aria-label": "Add table",
                children: /* @__PURE__ */ e(Ke, {})
              }
            ) }) }) }),
            /* @__PURE__ */ e(h.ControlsGroup, { children: /* @__PURE__ */ e(w, { gap: 4, children: /* @__PURE__ */ e(T, { label: "Horizontal line", children: /* @__PURE__ */ e(
              I,
              {
                variant: "tertiary",
                size: "sm",
                onClick: () => t == null ? void 0 : t.chain().focus().setHorizontalRule().run(),
                "aria-label": "Horizontal line",
                children: /* @__PURE__ */ e(qt, {})
              }
            ) }) }) }),
            (u == null ? void 0 : u.customButtons) && u.customButtons.length > 0 && /* @__PURE__ */ a(_, { children: [
              /* @__PURE__ */ e(Z, { orientation: "vertical" }),
              u.customButtons.map((i, x) => i.menu ? /* @__PURE__ */ a(
                o,
                {
                  withSearch: i.menu.withSearch,
                  searchPlaceholder: i.menu.searchPlaceholder,
                  children: [
                    /* @__PURE__ */ e(o.Target, { children: /* @__PURE__ */ a(
                      I,
                      {
                        variant: "tertiary",
                        size: "sm",
                        "aria-label": i.label,
                        children: [
                          i.icon,
                          /* @__PURE__ */ e(T, { label: i.label, children: /* @__PURE__ */ e("div", { className: d.buttonTooltip }) })
                        ]
                      }
                    ) }),
                    /* @__PURE__ */ e(o.Dropdown, { children: i.menu.items.length === 0 && i.menu.emptyState ? /* @__PURE__ */ a(he, { align: "center", justify: "center", py: "xl", px: "md", children: [
                      i.menu.emptyState.icon && /* @__PURE__ */ e(de, { c: "gray.5", children: /* @__PURE__ */ e(Jt, { size: 24 }) }),
                      /* @__PURE__ */ a(he, { gap: "xxs", align: "center", children: [
                        i.menu.emptyState.title && /* @__PURE__ */ e(de, { size: "md", fw: 500, c: "gray.9", children: i.menu.emptyState.title }),
                        i.menu.emptyState.description && /* @__PURE__ */ e(de, { size: "sm", c: "gray.7", ta: "center", children: i.menu.emptyState.description })
                      ] }),
                      i.menu.emptyState.buttonLabel && /* @__PURE__ */ e(
                        I,
                        {
                          variant: "primary",
                          size: "md",
                          onClick: i.menu.emptyState.onButtonClick,
                          leftSection: /* @__PURE__ */ e(We, {}),
                          children: i.menu.emptyState.buttonLabel
                        }
                      )
                    ] }) : i.menu.items.map((R, ce) => /* @__PURE__ */ e(
                      o.Item,
                      {
                        onClick: () => {
                          const O = t;
                          O && O.commands.insertContent(R.value);
                        },
                        children: R.label
                      },
                      ce
                    )) })
                  ]
                },
                x
              ) : /* @__PURE__ */ e(T, { label: i.label, children: /* @__PURE__ */ e(
                I,
                {
                  variant: "tertiary",
                  size: "sm",
                  onClick: i.onClick,
                  "aria-label": i.label,
                  children: i.icon
                }
              ) }, x))
            ] }),
            /* @__PURE__ */ e(h.ControlsGroup, { ml: "auto", children: /* @__PURE__ */ e(w, { gap: 4, children: /* @__PURE__ */ e(T, { label: L ? "Switch to editor" : "Switch to HTML", children: /* @__PURE__ */ e(
              I,
              {
                variant: "tertiary",
                size: "sm",
                onClick: () => k(!L),
                "data-active": L,
                className: d.codeButton,
                "aria-label": L ? "Switch to editor" : "Switch to HTML",
                children: /* @__PURE__ */ e(Wt, {})
              }
            ) }) }) })
          ] }),
          t && /* @__PURE__ */ e(Qt, { editor: t }),
          t && re && /* @__PURE__ */ e(
            o,
            {
              opened: re,
              onClose: () => A(!1),
              position: "bottom-start",
              offset: 2,
              styles: {
                dropdown: {
                  position: "fixed",
                  left: `${me.x}px`,
                  top: `${me.y}px`,
                  zIndex: 1e3
                }
              },
              children: /* @__PURE__ */ a(o.Dropdown, { classNames: { dropdown: d.tableMenu }, children: [
                (t == null ? void 0 : t.can().addColumnBefore()) && /* @__PURE__ */ a(_, { children: [
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => {
                        t == null || t.chain().focus().addColumnBefore().run(), A(!1);
                      },
                      leftSection: /* @__PURE__ */ e(Xe, {}),
                      children: "Add column to left"
                    }
                  ),
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => {
                        t == null || t.chain().focus().addColumnAfter().run(), A(!1);
                      },
                      leftSection: /* @__PURE__ */ e(Ve, {}),
                      children: "Add column to right"
                    }
                  ),
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => {
                        t == null || t.chain().focus().deleteColumn().run(), A(!1);
                      },
                      leftSection: /* @__PURE__ */ e(Ce, {}),
                      children: "Delete column"
                    }
                  )
                ] }),
                (t == null ? void 0 : t.can().addRowBefore()) && /* @__PURE__ */ a(_, { children: [
                  /* @__PURE__ */ e(o.Divider, {}),
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => {
                        t == null || t.chain().focus().addRowBefore().run(), A(!1);
                      },
                      leftSection: /* @__PURE__ */ e(Qe, {}),
                      children: "Add row above"
                    }
                  ),
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => {
                        t == null || t.chain().focus().addRowAfter().run(), A(!1);
                      },
                      leftSection: /* @__PURE__ */ e(Ye, {}),
                      children: "Add row below"
                    }
                  ),
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => {
                        t == null || t.chain().focus().deleteRow().run(), A(!1);
                      },
                      leftSection: /* @__PURE__ */ e(Ce, {}),
                      children: "Delete row"
                    }
                  )
                ] }),
                (t == null ? void 0 : t.can().mergeCells()) && /* @__PURE__ */ a(_, { children: [
                  /* @__PURE__ */ e(o.Divider, {}),
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => {
                        t == null || t.chain().focus().mergeCells().run(), A(!1);
                      },
                      leftSection: /* @__PURE__ */ e(Ze, {}),
                      children: "Merge cells"
                    }
                  )
                ] }),
                (t == null ? void 0 : t.can().splitCell()) && /* @__PURE__ */ a(_, { children: [
                  /* @__PURE__ */ e(o.Divider, {}),
                  /* @__PURE__ */ e(
                    o.Item,
                    {
                      onClick: () => {
                        t == null || t.chain().focus().splitCell().run(), A(!1);
                      },
                      leftSection: /* @__PURE__ */ e(et, {}),
                      children: "Split cells"
                    }
                  )
                ] }),
                /* @__PURE__ */ e(
                  o.Item,
                  {
                    onClick: () => {
                      t == null || t.chain().focus().toggleHeaderCell().run(), A(!1);
                    },
                    leftSection: /* @__PURE__ */ e(tt, {}),
                    children: t != null && t.isActive("tableHeader") ? "Unmake header cell" : "Make header cell"
                  }
                ),
                /* @__PURE__ */ e(o.Divider, {}),
                /* @__PURE__ */ e(
                  o.Item,
                  {
                    "data-danger": !0,
                    onClick: () => {
                      t == null || t.chain().focus().deleteTable().run(), A(!1);
                    },
                    leftSection: /* @__PURE__ */ e(nt, {}),
                    children: "Delete table"
                  }
                )
              ] })
            }
          ),
          L ? /* @__PURE__ */ e("div", { className: d.codeEditor, children: /* @__PURE__ */ e(
            be,
            {
              value: F,
              onChange: B,
              multiline: !0,
              autosize: !0,
              minRows: 1,
              "data-plum-id": "rich-text-code-editor",
              styles: {
                input: {
                  fontFamily: "monospace",
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  overflowWrap: "break-word",
                  height: "auto!important"
                }
              },
              label: void 0
            }
          ) }) : /* @__PURE__ */ e(h.Content, { onContextMenu: Y })
        ]
      })
    ),
    c && /* @__PURE__ */ e(Rt, { error: c }),
    p && /* @__PURE__ */ e(de, { size: "sm", c: "gray.7", mt: 4, children: p })
  ] });
});
Vl.displayName = "RichText";
export {
  Xl as LineHeights,
  Vl as RichText
};
